<template>
	<div>
		<DashboardHeaderVue
			:title="$route.name"
			:buttonItems="buttonItems"
			@click="handleHeaderClick"
		/>
		<div class="container-fluid mt--6">
			<div class="row">
				<div class="col">
					<MembersTable
						:isLoading="isLoading"
						:tableData="allUsers"
						:tableHeaders="userTitles"
						@viewClicked="viewClicked"
						@deleteClicked="deleteClicked"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import DashboardHeaderVue from '../HeaderFooterComponents/DashboardHeader.vue';
import {
	getOrganizationDatabase,
	getOrganizationFirestore,
} from '../../../resources/organizationFirebase';
import { mapActions, mapGetters } from 'vuex';
import { ref, get } from '@firebase/database';
import MembersTable from '../../Components/MemberViews/MembersTable.vue';
import { DashboardChildren } from '../../../routes/routesNames';
import { httpsCallable } from '@firebase/functions';
import { functions } from '../../../resources/firebase';
import { collection, getDocs } from '@firebase/firestore';

export default {
	name: 'shop',
	computed: {
		...mapGetters({
			organization: 'getOrganization',
		}),
	},
	components: {
		DashboardHeaderVue,
		MembersTable,
	},
	data() {
		return {
			isLoading: true,
			buttonItems: [
				{
					index: 0,
					title: 'Export Users',
					type: 'primary',
					isDisabled: true,
					icon: 'fas fa-download',
				},
			],
			activeWaiverId: null,
			allUsers: [],
			userTitles: [
				{
					key: 'nameAndPhoto',
					label: 'Name',
					sortable: true,
					tdClass: 'align-middle',
					sortByFormatted: (value, key, item) => {
						return item.firstName + item.lastName;
					},
				},
				{
					key: 'email',
					label: 'Email',
					sortable: true,
					tdClass: 'align-middle',
				},
				{
					key: 'username',
					label: 'Username',
					tdClass: 'align-middle',
				},
				{
					key: 'uid',
					label: 'Unique Id',
					tdClass: 'align-middle',
				},
			],
		};
	},
	watch: {
		isLoading(val) {
			this.buttonItems[0].isDisabled = val;
		},
	},
	methods: {
		...mapActions(['showNotification']),
		handleHeaderClick(buttonItem) {
			if (buttonItem.index == 0) {
				this.checkIfExportAllowed();
			}
		},
		getUsers() {
			const firestore = getOrganizationFirestore(this.organization);
			const firestoreRef = collection(firestore, 'users');
			getDocs(firestoreRef).then((snapshot) => {
				if (!snapshot.empty) {
					snapshot.forEach((item) => {
						var user = item.data();
						this.allUsers.push(user);
						this.allUsers.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1));
					});
					this.isLoading = false;
				}
			});
		},
		checkIfExportAllowed() {
			/*
			const database = getOrganizationDatabase(this.organization);
			const reportsRef = ref(database, 'reports');
			get(reportsRef).then((snapshot) => {
				if (snapshot.exists()) {
					var previousReports = [];
					var todayDate = new Date();
					var todayMonth = todayDate.getMonth() + 1;
					var todayYear = todayDate.getFullYear();
					snapshot.forEach((item) => {
						const reportData = item.val();
						const reportDate = new Date(reportData.reportDate);
						if (
							reportDate.getMonth() + 1 == todayMonth &&
							reportDate.getFullYear() == todayYear
						) {
							previousReports.push(reportData);
						}
					});
					if (previousReports.length >= 3) {
						this.showNotification({
							type: 'danger',
							message: `You have exceeded the amount of reports for this month.`,
						});
					} else {
						this.exportUsers();
					}
				} else {
					this.exportUsers();
				}
			});
			*/
		},
		exportUsers() {
			this.isLoading = true;
			const exportUsers = httpsCallable(functions, 'exportUsers');
			exportUsers({
				organization: this.organization,
				filename: `Users_Export - ${this.$helpers.formatDate(
					new Date(),
					'yyyy-MM-dd'
				)}`,
			})
				.then((response) => {
					this.isLoading = false;
					if (response.data.downloadUrl) {
						window.open(response.data.downloadUrl, '_blank');
					}
				})
				.catch((error) => {
					this.showNotification({
						type: 'danger',
						message: `${error.message}`,
					});
				});
		},
		viewClicked(item) {
			this.$router.push({
				name: DashboardChildren.memberProfile.name,
				query: {
					uid: item.uid,
				},
			});
		},
		deleteClicked(item) {
			console.log(`Moses delete on ${item}`);
		},
	},
	mounted() {
		this.getUsers();
	},
};
</script>
